// extracted by mini-css-extract-plugin
module.exports = {"wrapFlex":"ordersPage_wrapFlex__2EXwM","orderElement":"ordersPage_orderElement__V_Cth"};